import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilterState {
  searchText: string;
  setSearchText: (text: string) => void;
  clearFilters: () => void;
}

export const useFilterStore = create<FilterState>()(
  persist(
    (set) => ({
      searchText: '',

      setSearchText: (searchText) => set({ searchText }),

      clearFilters: () => set({ searchText: '' }),
    }),
    {
      name: 'filter-storage',
    }
  )
);
